import { render, staticRenderFns } from "./PortalPulpit.vue?vue&type=template&id=17c338de&"
import script from "./PortalPulpit.vue?vue&type=script&lang=js&"
export * from "./PortalPulpit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports